import React from 'react';

import {
  Drawer,
  ErrorHandler,
  LoadingState,
  StandardNoAccessErrorMessage,
  StandardNotFoundErrorMessage,
} from '@common/components';
import { useQuery } from '@common/hooks';
import { formatSummaryDate, parseInTz } from '@timekeeping/services';
import { HourBlockForm } from '@timekeeping/components';
import { ReviewHourBlockInfo } from '@timekeeping/graphql';

export const HourBlockEditDrawer = ({
  open,
  onClose,
  hourBlockId,
}: {
  open: boolean;
  onClose: () => void;
  hourBlockId?: string;
}) => {
  const { loading, data, error } = useQuery(ReviewHourBlockInfo, {
    skip: !hourBlockId,
    variables: { id: hourBlockId! },
  });

  const hourBlock = data?.hourBlockInfo?.data;

  const renderDrawerBody = () => {
    if (!hourBlockId) {
      return null;
    }

    if (loading) {
      return <LoadingState />;
    }

    if (error) {
      return <ErrorHandler log="HourBlockEditDrawer" error={error} />;
    }

    if (!hourBlock) {
      return <StandardNotFoundErrorMessage />;
    }

    if (!hourBlock?.workerTimesheet.canManagerUpsertHours.value) {
      return <StandardNoAccessErrorMessage />;
    }

    return (
      <HourBlockForm action="edit" hourBlock={hourBlock} onSuccess={onClose} />
    );
  };

  const title =
    hourBlock &&
    formatSummaryDate(
      parseInTz(hourBlock.inOut.startedAt!, hourBlock.inOut.startedAtTz)
    );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      className="HourBlockDrawer"
      title={title}
    >
      {renderDrawerBody()}
    </Drawer>
  );
};
